import { adjustLabelForOptionality } from './option-label'
import Sparkles from './Sparkles'
import React, { useEffect, useRef } from 'react'
import type { ProductOptionWithNameProps } from '../../../../../shared/js/Module'
import type { ChangeEvent, ReactNode } from 'react'

const SQUARE_TEXT = 'square_text'

const Radios = ({
  children,
  details,
  disabled,
  id,
  label,
  name,
  onChange,
  onFontChange,
  required,
  triggerFocus,
  values,
  // valid,
}: ProductOptionWithNameProps) => {
  const selectedValue = values.find(({ selected }) => selected)
  const selectedValueId = selectedValue?.id
  const descriptionId = details ? `description-input-${id}` : null
  const ariaDescribedBy = descriptionId
    ? { 'aria-describedby': descriptionId }
    : {}
  const fieldRef = useRef<HTMLInputElement>(null)

  let finalLabel: ReactNode = label
  if (!required) {
    finalLabel = adjustLabelForOptionality(label)
  }

  const squareText = SQUARE_TEXT === values?.[0]?.imgKind
  const containerClass = squareText ? 'etching-type-filters' : ''

  // When autofocus is expected, trigger it,
  // then move smoothly into view
  useEffect(() => {
    if (fieldRef.current && triggerFocus) {
      fieldRef.current.scrollIntoView({ behavior: 'smooth' })
      fieldRef.current.focus({ preventScroll: true })
    }
  }, [triggerFocus])

  return (
    <>
      <legend>{finalLabel}</legend>
      {descriptionId && (
        <div className='text-content'>
          <p id={descriptionId}>{details}</p>
        </div>
      )}
      <div className={`option-radios ${containerClass}`}>
        {values.map(
          ({
            description,
            id: valueId,
            imgURL,
            imgKind,
            label: valueLabel,
            preparationDays,
            // cents,
            cssColor,
            sparklingColor,
          }) => (
            <React.Fragment key={valueId}>
              <input
                defaultChecked={selectedValueId === valueId}
                disabled={disabled}
                id={`radio-${valueId}`}
                name={name}
                onChange={handleChange}
                ref={fieldRef}
                type='radio'
                value={valueId}
                {...ariaDescribedBy}
              />
              <label
                className={
                  'c-label c-label--image' +
                  (imgKind ? ` c-label--image-${imgKind}` : '') +
                  (!imgURL && cssColor ? ' c-label--color' : '') +
                  (!imgURL && sparklingColor ? ' c-label--color-sparkling' : '')
                }
                htmlFor={`radio-${valueId}`}
              >
                {imgURL && (
                  <img
                    src={imgURL}
                    className={`c-label__${imgKind}`}
                    alt={`Prévisualisation de ${valueLabel}`}
                  />
                )}
                {!imgURL && cssColor && (
                  <span style={{ backgroundColor: cssColor }}>
                    {sparklingColor && <Sparkles id={valueId} />}
                  </span>
                )}
                {squareText ? (
                  <div>
                    <strong>{valueLabel}</strong>
                    {description}
                    {/* {preparationDays > 0 && (
                      <span> (+{preparationDays} jours)</span>
                    )} */}
                  </div>
                ) : (
                  <span>{valueLabel}</span>
                )}
                {/* {cents > 0 && ` (${formatPrice(cents)})`} */}
              </label>
            </React.Fragment>
          )
        )}
      </div>

      {/* {!valid && (
        <p className='c-message c-message--help'>
          Vous devez choisir une option
        </p>
      )} */}

      {children}
    </>
  )

  function handleChange({
    target: { value: selectedId },
  }: ChangeEvent<HTMLInputElement>) {
    let selectedFontClassName = null
    const updatedValues = values.map((value) => {
      const selected = value.id === Number(selectedId)
      if (selected) {
        selectedFontClassName = value.fontClassName
      }
      return { ...value, selected }
    })
    onChange?.(id, updatedValues)
    // Prevent previous font selection to be era
    selectedFontClassName && onFontChange?.(selectedFontClassName)
  }
}

export default Radios
